import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Button} from "reactstrap";
import MaintenanceWorks from "./Stage2/MaintenanceWorks";
import useAfterUpdateEffect from "utils/useAfterUpdateEffect";
import {useTranslation} from "react-i18next";

const Stage2 = props => {
  const { t } = useTranslation('tec_rmi');
  const [data, setData] = useState(props.initialData ?? {
    works: [],
    mainWorkId: null,
    additionalWorkIds: [],
  })

  useAfterUpdateEffect(() => {
    props.onDataChange(data)
  }, [data])

  return (
    <React.Fragment>
      <MaintenanceWorks
        data={data}
        bodyQualColId={props.data.bodyForMaintenances}
        onDataChange={setData}
        serviceProposal={props.data.serviceProposal}
      />

      <div className="d-flex flex-row flex-nowrap justify-content-between">
        <Button color={'light'} onClick={props.prevStage}>
          <i className="fas fa-angle-left" />
          <span>{t('service_proposal.stage_2.btn_prev')}</span>
        </Button>
        <Button color={'primary'} onClick={props.nextStage}>
          <span>{t('service_proposal.stage_2.btn_next')}</span>
          <i className="fas fa-angle-right ml-2" />
        </Button>
      </div>
    </React.Fragment>
  );
};

Stage2.propTypes = {
  onDataChange: PropTypes.func.isRequired,
  prevStage: PropTypes.func.isRequired,
  nextStage: PropTypes.func.isRequired,
  data: PropTypes.shape({
    bodyForMaintenances: PropTypes.number.isRequired,
  }).isRequired,
};

export default Stage2;